import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { api } from './services/api';
import auth from './slices/authSlice';
import editPage from './slices/editPageSlice';
import employee from './slices/employeeSlice';
import workspace from './slices/workspaceSlice';

export const store = configureStore({
  reducer: {
    auth,
    editPage,
    employee,
    workspace,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootStateType = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootStateType,
  unknown,
  Action<string>
>;
